import React, { useState, useEffect } from 'react';
import AdminLogin from '../AdminLogin/AdminLogin';
import AdminDashboard from '../AdminDashboard/AdminDashboard';
import { adminAuthAPI } from '../../lib/supabase';

const Admin = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Check if user is already authenticated on component mount
  useEffect(() => {
    const checkAuth = () => {
      const authStatus = localStorage.getItem('adminAuthenticated');
      const authTime = localStorage.getItem('adminAuthTime');
      
      if (authStatus === 'true' && authTime) {
        const currentTime = new Date().getTime();
        const loginTime = parseInt(authTime);
        const sessionDuration = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
        
        // Check if session is still valid (24 hours)
        if (currentTime - loginTime < sessionDuration) {
          setIsAuthenticated(true);
        } else {
          // Session expired, clear storage
          localStorage.removeItem('adminAuthenticated');
          localStorage.removeItem('adminAuthTime');
          setIsAuthenticated(false);
        }
      }
      
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleLogin = async (credentials) => {
    try {
      // Authenticate with database
      const result = await adminAuthAPI.authenticate(credentials.username, credentials.password);
      
      if (result.success) {
        // Set authentication in localStorage with user data
        localStorage.setItem('adminAuthenticated', 'true');
        localStorage.setItem('adminAuthTime', new Date().getTime().toString());
        localStorage.setItem('adminUser', JSON.stringify(result.user));

        setIsAuthenticated(true);
        return { success: true, message: result.message };
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      throw { success: false, message: error.message || 'Authentication failed' };
    }
  };

  const handleLogout = () => {
    // Clear authentication from localStorage
    localStorage.removeItem('adminAuthenticated');
    localStorage.removeItem('adminAuthTime');
    localStorage.removeItem('adminUser');

    setIsAuthenticated(false);
  };

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          background: 'white',
          padding: '2rem',
          borderRadius: '15px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #667eea',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 1rem'
          }}></div>
          <p style={{ margin: 0, color: '#666' }}>Checking authentication...</p>
        </div>
      </div>
    );
  }

  // Render login or dashboard based on authentication status
  return (
    <>
      {isAuthenticated ? (
        <AdminDashboard onLogout={handleLogout} />
      ) : (
        <AdminLogin onLogin={handleLogin} />
      )}
      
      {/* Add spinner animation styles */}
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
};

export default Admin;